/**
 * Represents a criterion with a type and title.
 */
import RepositoryEntry from './RepositoryEntry';

class Criterion extends RepositoryEntry {
    /**
     * Creates a new instance of Criterion.
     */
    constructor(entry, $injector) {
        super(entry, $injector);

        this.accessables({
            'type': String,
            'title': String
        });

    }
}

export default Criterion;